import { Toast as BaseToast } from '@base-ui/react/toast';
import type { UseToastManagerReturnValue } from '@base-ui/react/toast';

export function useToastManager<
  Data extends object = Record<string, unknown>,
>(): UseToastManagerReturnValue<Data> {
  return BaseToast.useToastManager<Data>();
}
